// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LogsControlPage {
  padding-left: 281px;
  background: #EFF0F4;
  width: 100%;
  height: 100vh;
}
.LogsControlPage .PageContent {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 56px;
}
.LogsControlPage .PageContent .emptyList {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.LogsControlPage .PageContent .LoaderContainer {
  min-height: 487px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.LogsControlPage .PageContent .CardsContent {
  padding-left: 20px;
  padding-top: 20px;
  background: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 36px;
}
.LogsControlPage .PageContent .FirstControlPanel {
  display: flex;
  gap: 40px;
}
.LogsControlPage .PageContent .SecondControlPanelWrapper {
  display: flex;
  gap: 48px;
}
.LogsControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.1s;
}
.LogsControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover {
  color: rgb(173, 164, 164);
}
.LogsControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover svg path {
  transition: 0.1s;
  fill: rgb(173, 164, 164);
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/LogsControlPage/LogsControlPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACN;AAEI;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAAN;AAGI;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AADN;AAII;EACE,aAAA;EACA,SAAA;AAFN;AAKI;EACE,aAAA;EACA,SAAA;AAHN;AAIM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAFR;AAGQ;EACE,yBAAA;AADV;AAGY;EACE,gBAAA;EACA,wBAAA;AADd","sourcesContent":[".LogsControlPage {\r\n  padding-left: 281px;\r\n  background: #EFF0F4;\r\n  width: 100%;\r\n  height: 100vh;\r\n\r\n  .PageContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 32px;\r\n    margin-top: 56px;\r\n\r\n    .emptyList {\r\n      display: flex;\r\n      align-items: center;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      gap: 20px;\r\n    }\r\n\r\n    .LoaderContainer {\r\n      min-height: 487px;\r\n      height: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-direction: column;\r\n      align-items: center;\r\n    }\r\n\r\n    .CardsContent {\r\n      padding-left: 20px;\r\n      padding-top: 20px;\r\n      background: white;\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-direction: column;\r\n      gap: 36px;\r\n    }\r\n\r\n    .FirstControlPanel {\r\n      display: flex;\r\n      gap: 40px;\r\n    }\r\n\r\n    .SecondControlPanelWrapper {\r\n      display: flex;\r\n      gap: 48px;\r\n      .SecondControlPanelContent {\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        transition: 0.1s;\r\n        &:hover {\r\n          color: rgb(173, 164, 164);\r\n          svg {\r\n            path {\r\n              transition: 0.1s;\r\n              fill: rgb(173, 164, 164);\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LogsControlPage": `LogsControlPage`,
	"PageContent": `PageContent`,
	"emptyList": `emptyList`,
	"LoaderContainer": `LoaderContainer`,
	"CardsContent": `CardsContent`,
	"FirstControlPanel": `FirstControlPanel`,
	"SecondControlPanelWrapper": `SecondControlPanelWrapper`,
	"SecondControlPanelContent": `SecondControlPanelContent`
};
export default ___CSS_LOADER_EXPORT___;
